'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var observable = require('@trpc/server/observable');
var transformResult = require('../transformResult-26a22823.js');
var TRPCClientError = require('../TRPCClientError-dffb44e0.js');
var httpUtils = require('../httpUtils-cc69e11f.js');

function httpLinkFactory(factoryOpts) {
    return (opts)=>{
        const resolvedOpts = httpUtils.resolveHTTPLinkOptions(opts);
        return (runtime)=>({ op  })=>observable.observable((observer)=>{
                    const { path , input , type  } = op;
                    const { promise , cancel  } = factoryOpts.requester({
                        ...resolvedOpts,
                        runtime,
                        type,
                        path,
                        input,
                        headers () {
                            if (!opts.headers) {
                                return {};
                            }
                            if (typeof opts.headers === 'function') {
                                return opts.headers({
                                    op
                                });
                            }
                            return opts.headers;
                        }
                    });
                    let meta = undefined;
                    promise.then((res)=>{
                        meta = res.meta;
                        const transformed = transformResult.transformResult(res.json, runtime);
                        if (!transformed.ok) {
                            observer.error(TRPCClientError.TRPCClientError.from(transformed.error, {
                                meta
                            }));
                            return;
                        }
                        observer.next({
                            context: res.meta,
                            result: transformed.result
                        });
                        observer.complete();
                    }).catch((cause)=>{
                        observer.error(TRPCClientError.TRPCClientError.from(cause, {
                            meta
                        }));
                    });
                    return ()=>{
                        cancel();
                    };
                });
    };
}
const httpLink = httpLinkFactory({
    requester: httpUtils.jsonHttpRequester
});

exports.httpLink = httpLink;
exports.httpLinkFactory = httpLinkFactory;
